import React from "react";

const Kanban = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M33.008 2H2.992C2.448 2 2 2.513 2 3.06v3.553c0 .581.48 1.06.992 1.06h30.016c.544 0 .992-.513.992-1.06V3.06C34 2.513 33.52 2 33.008 2ZM32.847 9.808h-6.986c-.632 0-1.152.512-1.152 1.059v19.204c0 .581.558 1.06 1.152 1.06h6.986c.632 0 1.152-.513 1.152-1.06V10.867c0-.58-.557-1.06-1.152-1.06ZM10.138 9.808H3.152C2.52 9.808 2 10.32 2 10.867v22.074C2 33.52 2.557 34 3.152 34h6.986c.632 0 1.152-.513 1.152-1.06V10.868c0-.58-.557-1.06-1.152-1.06ZM21.493 9.808h-6.986c-.632 0-1.152.512-1.152 1.059v16.368c0 .581.557 1.06 1.152 1.06h6.986c.632 0 1.152-.513 1.152-1.06V10.867c0-.58-.558-1.06-1.152-1.06Z"
            fill={fill}
        />
    </svg>
);

export default Kanban;